import './scss/Card.scss';

type CardProps = {
  children: React.ReactNode;
  additionalClasses?: string;
  showBorder?: boolean;
  dataTestId?: string;
  style?: React.CSSProperties;
  id?: string;
};

export function Card({
  additionalClasses,
  children,
  dataTestId,
  style,
  id,
  showBorder = true,
}: CardProps) {
  const borderClass = showBorder ? 'border' : '';

  return (
    <div
      className={`portal-card ${borderClass} ${additionalClasses} position-relative`}
      style={style}
      data-testid={dataTestId}
      id={id}
    >
      {children}
    </div>
  );
}
